import React, { Component } from 'react'

import Text from '../text'

class Time extends Component {
  constructor (props) {
    super(props)

    this.state = {
    }

    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  onChange (e) {
    let val = e.target.value

    let sub = val.substr(1, 1)
    let sub2 = val.substr(2, 1)
    if (isNaN(parseInt(sub))) {
      if (sub !== ':' && sub !== '') {
        val = val.replace(sub, ':')
      }
    }
    if (isNaN(parseInt(sub2))) {
      if (sub2 !== ':' && sub2 !== '') {
        val = val.replace(sub2, ':')
      }
    }
    val = val.replace('::', ':')

    const event = {
      target: {
        name: this.props.name,
        value: val
      }
    }

    if (this.props.onChange !== null) {
      this.props.onChange(event)
    }
  }

  onBlur (e) {
    let val = e.target.value

    if (!(/[:]/.test(val))) {
      if (val.length === 3) {
        val = val.substr(0, 1) + ':' + val.substr(1, 2)
      } else if (val.length >= 4) {
        val = val.substr(0, 2) + ':' + val.substr(2, 2)
      }
    }

    const event = {
      target: {
        name: this.props.name,
        value: val
      }
    }

    if (this.props.onChange !== null) {
      this.props.onChange(event)
    }
  }

  render () {
    return (
      <Text
        {...this.props}
        value={this.props.value}
        onChange={this.onChange}
        onBlur={this.onBlur}
        maxLength={5}
      />
    )
  }
}

Time.defaultProps = {
  onChange: null
}

export default Time



// WEBPACK FOOTER //
// ./src/app/shared/elements/time/index.js